import { useApi, type APIParams, type APIRequest } from '@hooks/use-api-requests.hook.ts'
import { useAppContext } from '@hooks/use-app-context'
import type { Installment } from '@hooks/use-vm-model'
import { Actions } from '@store/reducer'
import * as React from 'react'

const POLL_SECONDS = 2
type PollingState = 'PENDING' | 'ACTIVE' | 'CLOSED' | 'EXPIRED' | 'REVIEW'

type BrowserSession = {
  idRichiesta: number
  source: 'MOBILE' | 'DESKTOP' | null
  status: PollingState | null
  disclaimer?: string 
  importo?:number
  RataSel?: Partial<Installment>
  descrMotivazione?:string
  insurance?:boolean

}

// ✅ CONFIG STABILE (fuori dal hook)
const GET_BROWSER_STATE: APIParams<BrowserSession> = {
  request: 'DbOperations/GetBrowserState' as APIRequest,
  method: 'GET',
  silent: true,
  sleeper: true,
}

export function useBrowserStatePolling(token: string) {
  const pollRef = React.useRef<number | null>(null)
  const [session, fetchSession] = useApi<BrowserSession>(GET_BROWSER_STATE)
  	const { dispatch } = useAppContext()

  const fetchRef = React.useRef(fetchSession)

  React.useEffect(() => {
    fetchRef.current = fetchSession
  }, [fetchSession])

 // console.log("SESSION FROM API",session)

  const start = React.useCallback(() => {
    if (!token) return
    if (pollRef.current) return

    // ✅ primo giro subito con query esplicita
    fetchRef.current({ query: { idMobileSession: token } } as any)

    pollRef.current = window.setInterval(() => {
      fetchRef.current({ query: { idMobileSession: token } } as any)
    }, POLL_SECONDS * 1000)
  }, [token])

  const stop = React.useCallback(() => {
    if (!pollRef.current) return
    clearInterval(pollRef.current)
    pollRef.current = null
  }, [])

  //SET DISCLIAMER on state.data

  React.useEffect(() => {
	if (!session) return


	dispatch({
	type: Actions.SetQrDisclaimer,
	payload: {
		disclaimer: session.disclaimer ?? '',
		importo: String(session.importo ?? '0'),
		rate: session.RataSel,
    descrMotivazione:session.descrMotivazione ?? '',
    insurance:session.insurance ?? false
    
	},
})

}, [session, dispatch])

  React.useEffect(() => stop, [stop])

  return { session, start, stop }
}